import { render, staticRenderFns } from "./FixedRidge.vue?vue&type=template&id=33cfccbc&"
import script from "./FixedRidge.vue?vue&type=script&lang=js&"
export * from "./FixedRidge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports